import { useEffect, useState } from 'react';

import { SharedNotificationService } from '../Services';

export function useNotificationSelectedUsers () {
  const sharedNotificationService = new SharedNotificationService();
  const [usersChecked, setUsersChecked] = useState([]);

  useEffect(() => {
    const subscription = sharedNotificationService
      .subscriberAsObservable
      .subscribe(userArray => {
        setUsersChecked(userArray);
      });

    return () => {
      subscription.unsubscribe();
    }
  }, []);

  const handleActionButtons = (row) => {
    console.log("handleActionButtons called for row:", row);
    console.log("Current usersChecked inside hook:", usersChecked);
    if (row) {
      const foundedUser = findUserById(row.id);
      console.log("foundedUser search result:", foundedUser);
      if (foundedUser && usersChecked?.length > 0) {
        onDelete(foundedUser);
      } else {
        addsNewRecord(row);
      }
    }
  }

  const addsNewRecord = (arrRecord) => {
    const updated = [ ...usersChecked, arrRecord ];
    console.log("addsNewRecord - setting subscriber to:", updated);
    setUserArraySubscriber(updated);
  }

  const setUserArraySubscriber = (values) => {
    sharedNotificationService.storeSubscriberValue = values;
  }

  const findUserById = (userId) => {
    console.log("findUserById checking userId:", userId);
    return usersChecked?.find(userChecked => userChecked.id === userId);
  }

  const onDelete = (values) => {
    const removedUsers = usersChecked?.filter
      (
        userChecked => userChecked.id !== values.id
      );
    console.log("onDelete - setting subscriber to:", removedUsers);
    setUserArraySubscriber(removedUsers);
  }

  const resetUsersArr = () => {
    setUserArraySubscriber([]);
    sharedNotificationService.lastLoadedRequestId = null;
  }

  const retrieveUserIds = () => {
    return usersChecked?.map(element => element.id);
  }

  const retrieveUserIdsFromParams = (users) => {
    return users?.map(element => element.id);
  }

  return {
    // State
    usersChecked,
    // Functions
    onDelete,
    findUserById,
    resetUsersArr,
    addsNewRecord,
    retrieveUserIds,
    retrieveUserIdsFromParams,
    handleActionButtons,
    setUserArraySubscriber,
  }
}
